module.exports = __webpack_public_path__ + "img/bg.940694e8.svg";